import { render, staticRenderFns } from "./MaterialCheck.vue?vue&type=template&id=2f10dc8a&scoped=true&"
import script from "./MaterialCheck.vue?vue&type=script&lang=js&"
export * from "./MaterialCheck.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCheck.vue?vue&type=style&index=0&id=2f10dc8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10dc8a",
  null
  
)

export default component.exports